import React, { useState } from 'react';
import HeaderBar from '../components/HeaderBar';
import Tabs from '../components/Tabs';
import SupplementCatalogList from '../components/SupplementCatalogList';
import MedicationCatalogList from '../components/MedicationCatalogList';

const ResourcesPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div style={{ padding: '0' }}>
      <HeaderBar title="Recursos" />
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
        <Tabs
          tabs={['Suplementos', 'Medicamentos']}
          selected={selectedTab}
          onSelect={setSelectedTab}
          style={{ marginBottom: 24 }}
        />
        {selectedTab === 0 && <SupplementCatalogList />}
        {selectedTab === 1 && <MedicationCatalogList />}
      </div>
    </div>
  );
};

export default ResourcesPage;
